module.exports = {
      id: "icon-facebook-usage",
      viewBox: "0 0 13.521 25.459",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#icon-facebook",
      toString: function () {
        return this.url;
      }
    }